//import { fenExoport } from "../home/index.jsx";
export const POSITION_CHANGED = "POSITION_CHANGED";

const initialState = {
  //tu dac Fen
  position: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case POSITION_CHANGED: {
      const newPosiotion = [...state.position, action.payload];
      return {
        ...state,
        position: newPosiotion,
      };
    }
    default: {
      console.warn(`Unknown action ${action.type}`);
      return { ...state };
    }
  }
};
